import { RESET_DATA } from '../actions/application';
import {
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_LOADING,
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS,
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED,
  SET_BUILD_PAGEVIEW,
} from "../actions/applicationBuild";

const defVal = {
  buildPackageState: 0, // 构建状态 0 未构建 1 构建中 2 构建完成 3 构建失败
  innerAndroidDownloadUrl: "", // 国内Android下载地址
  outterAndroidDownloadUrl: "", // 海外Android下载地址
  pageView: 0, // 页面展示 0 证书配置 1 构建结果
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS:
      return Object.assign({}, state, {
        buildPackageState: action.buildPackageState,
        innerAndroidDownloadUrl: action.innerAndroidDownloadUrl,
        outterAndroidDownloadUrl: action.outterAndroidDownloadUrl,
      });
    case SET_BUILD_PAGEVIEW:
      return Object.assign({}, state, {
        pageView: action.pageView
      });
    case RESET_DATA:
      return Object.assign({}, state, {
        buildPackageState: 0, // 构建状态 0 未构建 1 构建中 2 构建完成 3 构建失败
        innerAndroidDownloadUrl: "", // 国内Android下载地址
        outterAndroidDownloadUrl: "", // 海外Android下载地址
        pageView: 0, // 页面展示 0 证书配置 1 构建结果
      });

    default:
      return state;
  }
};
